import React from "react";
import AntdSteps, {StepsProps} from "antd/lib/steps";
import {withError} from '@fishx/tracker';

const Step = AntdSteps.Step;
interface FCProps extends React.FC<StepsProps> {
  Step: typeof Step;
}
export const Steps: FCProps = (props) =>{
  return <AntdSteps {...props} />;
}
Steps.Step = Step;
Steps.displayName = 'Spin';
export default withError(Steps);



// WEBPACK FOOTER //
// ./src/components/steps/index.tsx